// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // Import Authentication SDK
import { getFirestore } from "firebase/firestore"; // Import Firestore SDK
import { getStorage } from "firebase/storage"; // Import Storage SDK
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC6ZGy-r7ErfTuHTLGPyq6ryfXSDT7HrSo",
  authDomain: "shower-away.firebaseapp.com",
  databaseURL:
    "https://shower-away-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "shower-away",
  storageBucket: "shower-away.appspot.com",
  messagingSenderId: "842712776369",
  appId: "1:842712776369:web:66561e55e2f707a67a2c90",
  measurementId: "G-51Z46GWB1N",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); // Initialize Authentication object
export const db = getFirestore(app); // Initialize Firestore object
export const storage = getStorage(app); // Initialize Storage object
export const analytics = getAnalytics(app);
